import appOptions from './appOptions';
import utility from './utility';
import egtnlUtil from './egtnl-util';
import _ from 'lodash';

const validVatNumber = (countryCode, vatNumber) => {
    return `${appOptions.get(
        'baseBizopUrl'
    )}ecomTraveler/validVatNumber?travelerCountryCode=${countryCode}&travelerVatNumber=${vatNumber}&_restfully=true`;
};

const ecomHapiFormAttributes = (
    paymentFormType,
    hasTravelerFee,
    isBrazilPOS = false
) => {
    let url = `${appOptions.get(
        'baseBizopUrl'
    )}ecomHapi/formAttributes?_restfully=true&locale=${appOptions.get(
        'locale'
    )}`;
    // get based on tab data
    if (paymentFormType.length > 0) {
        url += `&paymentFormType=${paymentFormType}`;
    }

    // If the traveler fee is enabled, send back national ID information along with countries
    if (hasTravelerFee) {
        url += '&nationalID=true';
    }

    // If HA_BR checkout include site in order to require NationalID
    if (isBrazilPOS) {
        url += `&site=${appOptions.get('site')}`;
    }

    return url;
};

const ecomHapiResetSensitiveFormUuid = (paymentInstrumentUuid) => {
    let url = `${appOptions.get(
        'baseBizopUrl'
    )}ecomHapi/closeSession?paymentInstrumentUuid=${paymentInstrumentUuid}`;
    return url;
};

const completeVASInterstitial = (data) => {
    const {reservationUrl, propertyType} = data;
    return (
        `${appOptions.get(
            'baseBizopUrl'
        )}ecomVas/vasCheckout?locale=${appOptions.get('locale')}
            ${
                _.isUndefined(reservationUrl)
                    ? ''
                    : `&reservationLink=${reservationUrl}`
            }&zdaEnabled=false` + // TRAVCHK-10299: Harding coding to false until the backend is fixed
        '&hamorZdaEnabled=false' +
        `&brandName=${appOptions.get('site')}&origin=VAS_INTERSTITIAL` +
        `&listingType=${propertyType}&_restfully=true`
    );
};

const updateTotals = () => {
    // passing back flow to bypass price quote transformer in our proxy handler
    return (
        `${appOptions.get(
            utility.getBaseBizopUrl()
        )}ecomTraveler/updateTotals?_restfully=true` +
        `&site=${appOptions.get('site')}&locale=${appOptions.get('locale')}
    &flow=${appOptions.get('checkoutType')}`
    );
};

const urgencyServiceEndpoint = (type) => {
    return `${appOptions.get(
        utility.getBaseBizopUrl()
    )}urgency/${type}?site=${appOptions.get('site')}`;
};

const deleteSavedCard = (pi) => {
    return `/cko/api/paymentPreference/deletePIForLoggedInUser?pi=${pi}`;
};

const marketingOptInOut = () => {
    return `${appOptions.get(
        utility.getBaseBizopUrl()
    )}marketingOptInOut?site=${appOptions.get('site')}`;
};

const registerStubUser = () => {
    return `${appOptions.get(
        utility.getBaseBizopUrl()
    )}registerStubUser?site=${appOptions.get('site')}`;
};
const kickboxEmail = () => {
    return `${appOptions.get('verifyUrl')}email`;
};

const verifyPhone = () => {
    return `${appOptions.get('verifyUrl')}phone`;
};

const ckoApiUpdate = () => {
    return `${appOptions.get('apiUrl')}update?site=${appOptions.get(
        'site'
    )}&locale=${appOptions.get('locale')}`;
};

const ckoApiComplete = () => {
    return `${appOptions.get('apiUrl')}complete?site=${appOptions.get(
        'site'
    )}&locale=${appOptions.get('locale')}`;
};

const ckoApiVasComplete = () => {
    let url = `${appOptions.get('apiUrl')}vasComplete?site=${appOptions.get(
        'site'
    )}&locale=${appOptions.get('locale')}`;
    if (utility.isVasCart()) {
        url += '&isVasCart=true';
    }
    return url;
};

const ckoApiCreateVasCheckout = () => {
    let url = `${appOptions.get(
        'apiUrl'
    )}createVasCheckout?reservation=${appOptions.get(
        'reservationUrl'
    )}&unit=${appOptions.get('unitLink')}&countryCode=${appOptions.get(
        'countryCode'
    )}&listingTriad=${appOptions.get('listingTriad')}&site=${appOptions.get(
        'site'
    )}&locale=${appOptions.get('locale')}`;
    if (utility.isVasCart()) {
        url += '&isVasCart=true';
    }
    const source = appOptions.get('source');
    if (utility.isVasCart() && source) {
        url += `&source=${source}`;
    }
    if (
        utility.isVasCart() &&
        egtnlUtil.isInsurtechVrboVasIpsniffEnabledNoLog()
    ) {
        const inferredCountryCode = appOptions.get('inferredCountryCode');
        if (inferredCountryCode) {
            url += `&inferredCountryCode=${encodeURIComponent(
                inferredCountryCode
            )}`;
        }
    }
    return url;
};

const ckoApiPrepare = () => {
    return `${appOptions.get('apiUrl')}prepare?site=${appOptions.get(
        'site'
    )}&locale=${appOptions.get('locale')}`;
};

const ckoApiCommence = () => {
    return `${appOptions.get('apiUrl')}commence?site=${appOptions.get(
        'site'
    )}&locale=${appOptions.get('locale')}`;
};

const vasContentsFetch = (checkoutSessionId) => {
    return `${appOptions.get(
        'apiUrl'
    )}vasContents?checkoutSessionId=${checkoutSessionId}`;
};

const ckoApiResume = () => {
    return `${appOptions.get('apiUrl')}resume?site=${appOptions.get(
        'site'
    )}&locale=${appOptions.get('locale')}`;
};

const ckoApiAffirmUpdate = () => {
    return `${appOptions.get('apiUrl')}affirmUpdate`;
};

const requestBookingConfirmation = () => {
    return `${appOptions.get(
        utility.getBaseBizopUrl()
    )}ecomTraveler/getRequestBookingConfirmationPage?_restfully=true&unitLink=${appOptions.get(
        'unitLink'
    )}&quoteGuid=${appOptions.get('quoteGuid')}&locale=${appOptions.get(
        'locale'
    )}&site=${appOptions.get('site')}`;
};

const requestPaypalAoe = () => {
    const searchPath = window.__INITIAL_STATE__.params.searchPath;

    return `${appOptions.get(
        'baseBizopUrl'
    )}ecomTraveler/resumeOrder${searchPath}`;
};

const processPaymentRequestAoe = () => {
    return `${appOptions.get(
        utility.getBaseBizopUrl()
    )}ecomTraveler/processPaymentRequest?locale=${appOptions.get(
        'locale'
    )}&site=${appOptions.get(
        'site'
    )}&pdpComplianceEnabled=true&_restfully=true`;
};

export default {
    validVatNumber,
    ecomHapiResetSensitiveFormUuid,
    ecomHapiFormAttributes,
    completeVASInterstitial,
    updateTotals,
    urgencyServiceEndpoint,
    deleteSavedCard,
    marketingOptInOut,
    registerStubUser,
    kickboxEmail,
    verifyPhone,
    ckoApiUpdate,
    ckoApiComplete,
    ckoApiPrepare,
    ckoApiCommence,
    ckoApiResume,
    ckoApiVasComplete,
    ckoApiCreateVasCheckout,
    ckoApiAffirmUpdate,
    requestBookingConfirmation,
    requestPaypalAoe,
    processPaymentRequestAoe,
    vasContentsFetch,
};
